module.exports = __webpack_public_path__ + "img/ZingScriptRustR-Base.4022bfb3.svg";